import { render, staticRenderFns } from "./DeviceOtaLogs.vue?vue&type=template&id=16d31121&scoped=true"
import script from "./DeviceOtaLogs.vue?vue&type=script&lang=js"
export * from "./DeviceOtaLogs.vue?vue&type=script&lang=js"
import style0 from "./DeviceOtaLogs.vue?vue&type=style&index=0&id=16d31121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d31121",
  null
  
)

export default component.exports